import { baseDevConfig } from "./baseEnv";

export const testConfig = {
  ...baseDevConfig,
  FILE_SUFFIX: "",
  BACK_API_ENDPOINT_V2: "https://2tj1us1ebl.execute-api.ap-northeast-1.amazonaws.com/Prod",
}